import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';
import { ConfirmationDialogComponent, ConfirmationDialogConfig } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-confirmation-dialog-container',
  standalone: true,
  imports: [ConfirmationDialogComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-confirmation-dialog
      [isVisible]="isVisible"
      [config]="currentConfig"
      (confirmed)="onConfirmed()"
      (cancelled)="onCancelled()">
    </app-confirmation-dialog>
  `
})
export class ConfirmationDialogContainerComponent implements OnInit {
  isVisible = false;
  currentConfig: ConfirmationDialogConfig = {
    title: '',
    message: '',
    icon: 'warning'
  };
  
  private currentResolve?: (result: boolean) => void;

  constructor(private confirmationService: ConfirmationDialogService) {}

  ngOnInit(): void {
    this.confirmationService.confirmation$.subscribe(({ config, resolve }) => {
      this.currentConfig = config;
      this.currentResolve = resolve;
      this.isVisible = true;
    });
  }

  onConfirmed(): void {
    if (this.currentResolve) {
      this.currentResolve(true);
    }
    this.isVisible = false;
  }

  onCancelled(): void {
    if (this.currentResolve) {
      this.currentResolve(false);
    }
    this.isVisible = false;
  }
}